import { createSlice } from "@reduxjs/toolkit";

export type AppConfigDT = {
  albumMode: boolean;
};
export const appConfigHandleSlice = createSlice({
  name: "appConfigHandle",
  initialState: {
    albumMode: false,
  } as AppConfigDT,
  reducers: {
    setAlbumMode: (state, payload) => {
      state.albumMode = payload.payload;
    },
    toggleAlbumMode: (state) => {
      state.albumMode = !state.albumMode;
    },
  },
});

// 为每个 case reducer 函数生成 Action creators
export const { setAlbumMode, toggleAlbumMode } = appConfigHandleSlice.actions;

export default appConfigHandleSlice.reducer;
